import { useMemo } from "react";
import { useTable } from "react-table";
import Loader from "../loader/index";

const AppTable = ({ columns, data, isLoading, manualPagination = false }) => {
	const columnData = useMemo(() => columns, [columns]);
	const rowData = useMemo(() => data, [data]);
	const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
		useTable({
			columns: columnData,
			data: rowData ?? [],
			manualPagination,
		});
	return (
		<>
			{isLoading ? (
				<Loader />
			) : (
				<>
					<table
						{...getTableProps()}
						className="table table-box"
						style={{
							background: 'white',
							color: "#102747",
							width: "100%",
							height: '100%'
						}}
					>
						<thead>
							{headerGroups.map((headerGroup) => (
								<tr
									{...headerGroup.getHeaderGroupProps()}
									className="mytr"
									// style={{ background: "white" }}
								>
									{headerGroup.headers.map((column) => (
										<th
											{...column.getHeaderProps()}
											style={{
												// background: "white",
												// color: "black",
												fontSize: 12,
											}}
										>
											{column.render("Header")}
										</th>
									))}
								</tr>
							))}
						</thead>
						<tbody {...getTableBodyProps()}>
							{rows && rows?.length > 0 ? (
								rows.map((row, i) => {
									prepareRow(row);
									return (
										<tr {...row.getRowProps()}>
											{row.cells.map((cell) => {
												return (
													<td
														{...cell.getCellProps()}
														style={{
															borderBottom: "none",
															borderLeft: "1px solid #102747",
															borderRight: "0.2px solid #102747",
															justifyContent: "center",
														}}
													>
														{cell.render("Cell")}
													</td>
												);
											})}
										</tr>
									);
								})
							) : (
								<tr>
									<td colSpan={columns?.length}> No Record Found !!!</td>
								</tr>
							)}
						</tbody>
					</table>
					{manualPagination && (
						<div>
							{/* YOUR CLIENT SIDE PAGINATION COMPONENT BUILT USING REACT-TABLE UTILITY FUNCTIONS */}
						</div>
					)}
				</>
			)}
		</>
	);
};

export default AppTable;
